const CATALOG_ALIASES = {
    'Cyber Outside In': 'Cybersecurity',
};

export const IRL_REQUEST_CATALOG = {
    'Information Technology': [
        {
            folder: 'Application Architecture',
            request: 'Provide the current application architecture documentation.',
            high: true,
        },
        {
            folder: 'Application Architecture',
            request: 'Provide an inventory of core business applications and their principal functions.',
            high: true,
        },
        {
            folder: 'Application Architecture',
            request: 'Describe major application integrations and dependencies.',
        },
        {
            folder: 'Application Architecture',
            request: 'Provide details of planned application replacement or modernisation initiatives.',
        },
        {
            folder: 'Application Architecture',
            request: 'Describe the build vs. buy strategy for software components.',
            selected: false,
        },
        {
            folder: 'Infrastructure & Cloud',
            request: 'Provide cloud architecture diagrams and hosting environment documentation.',
            high: true,
        },
        {
            folder: 'Infrastructure & Cloud',
            request: 'Provide an inventory of infrastructure components including servers, storage and networking.',
        },
        {
            folder: 'Infrastructure & Cloud',
            request: 'Describe the cloud strategy and current cloud adoption maturity.',
        },
        {
            folder: 'Infrastructure & Cloud',
            request: 'Provide cloud spend reports for the last 12 months.',
        },
        {
            folder: 'Data & Analytics',
            request: 'Provide an overview of the data architecture and key data flows.',
            high: true,
        },
        {
            folder: 'Data & Analytics',
            request: 'Describe the BI and analytics platform landscape.',
        },
        {
            folder: 'Data & Analytics',
            request: 'Provide the data governance policy and data classification framework.',
        },
        {
            folder: 'Technology Roadmap',
            request: 'Provide the technology strategy document.',
            high: true,
        },
        {
            folder: 'Technology Roadmap',
            request: 'Provide the product and technology roadmap for the next 12–24 months.',
        },
        {
            folder: 'Technology Roadmap',
            request: 'Describe planned technology investments and estimated costs.',
        },
        {
            folder: 'Vendor & Contracts',
            request: 'Provide a list of key technology vendors and their contract values.',
        },
        {
            folder: 'Vendor & Contracts',
            request: 'Provide copies of key vendor contracts and SLA agreements.',
        },
        {
            folder: 'Vendor & Contracts',
            request: 'Describe the software licensing position including any volume or enterprise agreements.',
        },
        {
            folder: 'IT Operations',
            request: 'Describe the IT service management framework and tooling.',
        },
        {
            folder: 'IT Operations',
            request: 'Provide service desk performance reports for the last 12 months.',
            selected: false,
        },
    ],
    Cybersecurity: [
        {
            folder: 'Security Policies & Standards',
            request: 'Provide the information security policy and supporting standards.',
            high: true,
        },
        {
            folder: 'Security Policies & Standards',
            request: 'Describe the security governance structure and key security roles.',
        },
        {
            folder: 'Security Policies & Standards',
            request: 'Provide the most recent security risk assessment and risk register.',
            high: true,
        },
        {
            folder: 'Vulnerability Management',
            request: 'Provide the most recent vulnerability scan reports.',
            high: true,
        },
        {
            folder: 'Vulnerability Management',
            request: 'Describe the patch management process and current patch status.',
        },
        {
            folder: 'Incident Response',
            request: 'Provide the incident response plan.',
            high: true,
        },
        {
            folder: 'Incident Response',
            request: 'Describe any significant security incidents in the last 24 months.',
        },
        {
            folder: 'Compliance & Certifications',
            request: 'Provide current security certifications (ISO 27001, SOC 2, Cyber Essentials, etc.).',
            high: true,
        },
        {
            folder: 'Compliance & Certifications',
            request: 'Provide the most recent penetration test report and remediation status.',
        },
    ],
};

export function irlCatalogForWorkstream(name) {
    if (IRL_REQUEST_CATALOG[name]) return IRL_REQUEST_CATALOG[name];
    const alias = CATALOG_ALIASES[name];
    return alias ? IRL_REQUEST_CATALOG[alias] || [] : [];
}

export function irlWhyText(folder, workstreamName) {
    return `Suggested because ${folder} is in scope and the VDR includes a ${folder} folder under ${workstreamName}.`;
}
